import {
  type ExampleCompaniesCheckInputs,
  useExampleCompaniesCheckQuery,
} from '@/modules/jobs/queries/useExampleCompaniesCheckQuery';
import { exampleCompaniesNote } from '@/modules/jobs/signal/exampleCompanies';

/**
 * The note under a job form's example companies: the companies that weren't found, and when the examples disagree
 * with the size band or industries the job prefers. Nothing while the check runs, when it fails, or when there's
 * nothing to say.
 */
export function ExampleCompaniesNote({
  className,
  ...inputs
}: ExampleCompaniesCheckInputs & { className?: string }) {
  const check = useExampleCompaniesCheckQuery(inputs);
  const sentences = check.data
    ? exampleCompaniesNote(check.data, inputs.employerSize)
    : [];
  if (sentences.length === 0) return null;
  return (
    <p role="status" className={className}>
      {sentences.join(' ')}
    </p>
  );
}
